
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/partner-aws",
      function () {
        return require("private-next-pages/services/partner-aws.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/partner-aws"])
      });
    }
  